import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { NoticeType } from '../../types/common.types';

import { addSystemNotice } from '../../slices/system/system.slice';

export type ToasterActions = {
  showToaster: (type: NoticeType, message: string) => void;
};

const useToaster = (): ToasterActions => {
  const dispatch: Dispatch = useDispatch();

  const showToaster: (type: NoticeType, message: string) => void = useCallback(
    (type: NoticeType, message: string): void => {
      dispatch(addSystemNotice({ type, message }));
    },
    [dispatch]
  );

  return { showToaster };
};

export default useToaster;
